import { render, staticRenderFns } from "./StudentScholarshipPreview.vue?vue&type=template&id=f8b362ac&scoped=true"
import script from "./StudentScholarshipPreview.vue?vue&type=script&lang=js"
export * from "./StudentScholarshipPreview.vue?vue&type=script&lang=js"
import style0 from "./StudentScholarshipPreview.vue?vue&type=style&index=0&id=f8b362ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b362ac",
  null
  
)

export default component.exports